import { render, staticRenderFns } from "./WorkspaceRoles.vue?vue&type=template&id=23f47386&scoped=true"
import script from "./WorkspaceRoles.vue?vue&type=script&lang=js"
export * from "./WorkspaceRoles.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceRoles.vue?vue&type=style&index=0&id=23f47386&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f47386",
  null
  
)

export default component.exports